import { API } from '../Auth';

const EP = 'discoverRuns';
const BASE = '/api/v1/drivers';

export async function listDrivers() {
  const response = await API.get(EP, BASE);
  return Array.isArray(response?.drivers) ? response.drivers : [];
}

export async function getDriverCatalog() {
  const response = await API.get(EP, `${BASE}/catalog`);
  return Array.isArray(response) ? response : [];
}

/**
 * Submit a new driver. `flavorId` is the catalog flavor (e.g. "ORACLE") or "CUSTOM".
 * `customFields` is only consumed when flavorId === "CUSTOM"; expected keys: typeName,
 * driverClassName, displayName, jdbcUrlTemplate, defaultPort, defaultSchema,
 * identifierQuoteStyle, jdbcUrlOnly.
 */
export async function addDriver(flavorId, file, customFields = {}) {
  const form = new FormData();
  form.append('file', file);
  form.append('flavorId', flavorId);
  Object.entries(customFields).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') {
      form.append(k, v);
    }
  });
  return API.post(EP, BASE, form);
}

export async function updateDriverType(typeName, body) {
  return API.patch(EP, `${BASE}/types/${encodeURIComponent(typeName)}`, body);
}

export async function deleteDriverType(typeName) {
  return API.del(EP, `${BASE}/types/${encodeURIComponent(typeName)}`);
}

// Worker-rejected uploads come back as a structured envelope from the platform API:
//   { code, message, downstreamStatus, downstreamBody }
// where downstreamBody is itself a JSON string from the worker (e.g. discover) like
// `{"error":"Uploaded file is not a valid JAR archive — git lfs pointer …"}`. The default
// `e.message` from ApiError only captures the request line + status code; the actionable
// text is buried in `e.body.downstreamBody`. Pull it out so the operator sees *why* the
// worker rejected the file, not just that the request 502'd.
export function extractWorkerReason(apiBody) {
  if (!apiBody) return null;
  const raw = apiBody.downstreamBody;
  if (!raw) return null;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        return parsed.error || parsed.message || raw;
      }
    } catch {
      // not JSON — surface the raw string verbatim
    }
    return raw;
  }
  if (typeof raw === 'object') {
    return raw.error || raw.message || JSON.stringify(raw);
  }
  return String(raw);
}
